import * as sellers from "./sellers";
import * as products from "./products";
import * as content from "./content";
import * as accounts from "./accounts";
import * as notification from "./notification";
import * as locations from "./locations";
import * as orders from "./orders";
import * as rates from "./rates";
import * as cars from "./cars";
import * as service_center from "./service_center";
import * as drivers_app from "./drivers_app";
import * as appointment from "./appointment";
import * as stocks from "./stocks";
import * as employees from "./employees";
import * as language from "./language";
import * as  qrLocation  from "./qr_location";

export const realList = {
  sellers,
  products,
  content,
  accounts,
  notification,
  locations,
  orders,
  rates,
  cars,
  service_center,
  drivers_app,
  appointment,
  stocks,
  employees,
  language,
  qrLocation
};
